import {cx} from '@local/utils/cx'

import type {ReactNode} from 'react'

export interface TagProps {
	children: ReactNode
	className?: string
	theme?: 'white' | 'grey' | 'dark'
}

export const Tag = ({children, className, theme = 'white'}: TagProps) => {
	return (
		<span className={cx(
			'inline-flex items-center h-20 px-8 pt-2',
			'text-10 uppercase text-black leading-tight',
			theme === 'white' && 'bg-white',
			theme === 'grey' && 'bg-black/10 text-black/80',
			theme === 'dark' && 'bg-white/20 text-white',
			className)}>
			{children}
		</span>
	)
}
